import React from 'react';
import './Logo.css';

const Logo = () => {
  return (
    <div className="logo-container">
      <svg
        width="100%"
        height="100%"
        viewBox="0 0 100 100"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="logo-svg"
      >
        {/* Bottom Chevron (Deep Oxford Navy) */}
        <path
          d="M20 75 L50 45 L80 75"
          stroke="#1e40af"
          strokeWidth="12"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        {/* Top Chevron (Classic Royal Trust Blue) */}
        <path
          d="M20 50 L50 20 L80 50"
          stroke="#3b82f6"
          strokeWidth="12"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </div>
  );
};

export default Logo;
